export default {
    routerName: '',
    locked: 'ロック中',
    unLock: 'アンロック',
    passwordPlaceholder: 'ログインパスワード',
};
